import type { PasswordRequirementFeedback as PasswordFeedbackModel } from "../../auth/passwordPolicy";

type Props = {
  feedback: PasswordFeedbackModel;
};

/** Bullets + strength line used under every “new password” field (register, reset, etc.). */
export default function PasswordRequirementFeedback({ feedback }: Props) {
  return (
    <div className="small lh-sm mt-1 mt-md-2 mb-0">
      {feedback.intro ? (
        <p className={`mb-0 mb-md-1 fw-semibold ${feedback.className}`}>
          <small className="d-md-none">{feedback.intro}</small>
          <span className="d-none d-md-inline">{feedback.intro}</span>
        </p>
      ) : null}
      {feedback.strengthLabel ? (
        <p className={`mb-0 mb-md-1 fw-semibold ${feedback.className}`}>
          <small className="d-md-none">{feedback.strengthLabel}</small>
          <span className="d-none d-md-inline">{feedback.strengthLabel}</span>
        </p>
      ) : null}
      {feedback.stillNeededCaption ? (
        <p className={`mb-0 mb-md-1 ${feedback.className}`}>
          <small className="d-md-none">{feedback.stillNeededCaption}</small>
          <span className="d-none d-md-inline">{feedback.stillNeededCaption}</span>
        </p>
      ) : null}
      {feedback.missingBullets.length > 0 ? (
        <ul className={`mb-0 ps-3 ${feedback.className}`}>
          {feedback.missingBullets.map((line) => (
            <li key={line} className="mb-0 lh-sm">
              <small className="d-md-none">{line}</small>
              <span className="d-none d-md-inline">{line}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
